<template>
    <div>
        <common-table :url="url" :table-columns="tableColumns" :form-fields="formFields" :operate="operate" :permission="permission" :searchs="searchs" ref="table"></common-table>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    import request from  "@/utils/axios.js";
    import message from "../../utils/message";

    export default {
        name: "BankCardInfo",
        components: {CommonTable},
        data(){
            return{
                searchs:[
                    {
                        name: 'username',
                        placeholder: '用户名',
                        type: 'input'
                    },{
                        name: 'cardNum',
                        placeholder: '卡号',
                        type: 'input'
                    },{
                        name: 'status',
                        placeholder: '请选择状态',
                        type: 'select',
                        selectValue:[{
                            key: 0,
                            value: "审核失败"
                        }, {
                            key: 1,
                            value: "审核成功"
                        }, {
                            key: 2,
                            value: "审核中"
                        }]
                    },
                    {
                        name: 'startTime',
                        placeholder: '开始时间',
                        type: 'dateTime'
                    },
                    {
                        name: 'endTime',
                        placeholder: '结束时间',
                        type: 'dateTime'
                    }
                ],
                permission:{
                    add: 'bankCardInfo:add',
                    update: 'bankCardInfo:update',
                    delete: 'bankCardInfo:delete',
                    deleteBatch: 'bankCardInfo:deleteBatch'
                },
                url: {
                    get: '/bankCardInfo/listByCondition',
                    //add: '/bankCardInfo/add',
                    //update: '/bankCardInfo/update',
                    delete: '/bankCardInfo/delete/',
                    delete_batch: '/bankCardInfo/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '75',
                },{
                    field: 'cardNum',
                    label: '卡号',
                    show: true,
                    width: '',
                },{
                    field: 'name',
                    label: '姓名',
                    show: true,
                    width: '',
                },{
                    field: 'bankName',
                    label: '银行名称',
                    show: true,
                    width: '',
                },{
                    field: 'branchName',
                    label: '支行名称',
                    show: true,
                    width: '',
                },{
                    field: 'provinces',
                    label: '开户省份',
                    show: true,
                    width: '',
                },{
                    field: 'city',
                    label: '开户城市',
                    show: true,
                    width: '',
                },{
                    field: 'userNick',
                    label: '用户昵称',
                    show: true,
                    width: '',
                },{
                    field: 'status',
                    label: '状态',
                    show: {
                        type: 'tag',
                        tags: [{
                            key: 1,
                            value: '通过审核',
                            type: 'success'
                        },{
                            key: 0,
                            value: '审核失败',
                            type: 'danger'
                        },{
                            key: 2,
                            value: '审核中',
                            type: 'info'
                        }]
                    },
                    width: '',
                },{
                    field: 'createTime',
                    label: '创建时间',
                    show: true,
                    width: '',
                }],
                formFields: {
                    addTitle: '添加银行卡',
                    updateTitle: '修改银行卡',
                    labelWidth: '105px',
                    model: [{
                        field: 'name',
                        label: '银行名称：',
                        type: 'input',
                        placeholder: '银行名称',
                        rules:[{required: true, message: '请输入银行名称', trigger: 'blur'}],
                        add: true,
                        update: true,
                    },{
                        field: 'icon',
                        label: '银行图标：',
                        type: 'input',
                        placeholder: '银行图标',
                        rules:[{required: true, message: '请输入银行图标', trigger: 'blur'}],
                        add: true,
                        update: true,
                    },{
                        field: 'color',
                        label: '颜色：',
                        type: 'input',
                        placeholder: '颜色',
                        rules:[{required: true, message: '请输入颜色', trigger: 'blur'}],
                        add: true,
                        update: true,
                    },{
                        field: 'bgIcon',
                        label: '背景图：',
                        type: 'input',
                        placeholder: '背景图',
                        rules:[{required: true, message: '请输入背景图', trigger: 'blur'}],
                        add: true,
                        update: true,
                    }],
                },
                operate: [{
                    icon: 'el-icon-edit',
                    type: 'text',
                    text: '审核通过',
                    handle: (row) => {
                        if (row.status != 2){
                            message.warning("已审核，不可重复审核");
                            return;
                        }
                        request.post({
                            url: '/bankCardInfo/audit',
                            data: {id: row.id, status : 1},
                            confirm: '确定审核通过？',
                            success: (data) => {
                                if (data.code == 0){
                                    message.success("操作成功");
                                    this.$refs.table.getData();
                                }else {
                                    message.error("操作失败");
                                }
                            }
                        });
                    }
                },{
                    icon: 'el-icon-edit',
                    type: 'text',
                    text: '审核失败',
                    handle: (row) => {
                        if (row.status != 2){
                            message.warning("已审核，不可重复审核");
                            return;
                        }
                        request.post({
                            url: '/bankCardInfo/audit',
                            data: {id: row.id, status : 0},
                            confirm: '确定审核失败？',
                            success: (data) => {
                                if (data.code == 0){
                                    message.success("操作成功");
                                    this.$refs.table.getData();
                                }else {
                                    message.error("操作失败");
                                }
                            }
                        });
                    }
                }],
            }
        }
    }
</script>

<style scoped>

</style>
